import React, { useEffect } from "react";
//style
import "./styled.css";
//redux
import { connect } from "react-redux";
//component
import Audio from "../../../components/audio";
//tags
import MetaTags from "react-meta-tags";

function Home(props) {
  useEffect(() => {
    document.getElementById("title-home").focus();
  }, []);
  return (
    <section className="section-home">
      <MetaTags>
        <title>Digital Lovers Festival - Página Home</title>
      </MetaTags>
      <a id="title-home" className="title-home" tabIndex={12}>
        Página Home
      </a>
      {/* <div className="card-home">
        <a style={{ fontSize: 23 }} tabIndex={13}>
          Audio NTT
        </a>
        <Audio tab={14} />
      </div> */}
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Home);
